import {
  UPDATE_SETTINGS_SITE_DATA,
  UPDATE_PRODUCT_DETAILS,
  UPDATE_CATALOG,
  UPDATE_HAS_BEEN_REDIRECTED,
  UPDATE_SUB_ORIGIN,
  UPDATE_ME_MENU_AVAILABLE,
  SESSION_TOKEN_AVAILABLE,
  UPDATE_ME_MENU_LOADING,
} from './types';

export const updateSettingsSiteData = (data) => {
  return {
    type: UPDATE_SETTINGS_SITE_DATA,
    payload: data,
  };
};
export const updateProductDetails = (data) => {
  return {
    type: UPDATE_PRODUCT_DETAILS,
    payload: data,
  };
};
export const updateCatalog = (data) => {
  return {
    type: UPDATE_CATALOG,
    payload: data,
  };
};
export const updateHasBeedRedirected = () => {
  return {
    type: UPDATE_HAS_BEEN_REDIRECTED,
  };
};

export const updateSubOrigin = (str) => {
  return {
    type: UPDATE_SUB_ORIGIN,
    payload: str,
  };
};

export const updateMeMenuAvailable = (data) => {
  return {
    type: UPDATE_ME_MENU_AVAILABLE,
    payload: data,
  };
};

export const updateMeMenuLoading = (data) => {
  return {
    type: UPDATE_ME_MENU_LOADING,
    payload: data,
  };
};

export const updateSessionTokenAvailable = (str) => {
  return {
    type: SESSION_TOKEN_AVAILABLE,
    payload: str,
  };
};

